// extracted by mini-css-extract-plugin
export default {"items":"Shop_items__r+TTy","alovera":"Shop_alovera__ZgUV8","example":"Shop_example__YVPQl"};